import { URI_REPORT } from '@/config/config'

export default async ({ rootState }, { licencePlate, cursor, limit }) => {
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    }
  }

  const params = new URLSearchParams()
  if (cursor) params.set('cursor', cursor)
  if (limit) params.set('limit', limit)
  const queryString = params.toString()
  const url = `${URI_REPORT}vehicle/history/${licencePlate}${queryString ? `?${queryString}` : ''}`

  try {
    const userLoginInfoResult = await fetch(url, opts)
    const resultJson = await userLoginInfoResult.json()

    if (userLoginInfoResult.status !== 200) {
      return Promise.reject(resultJson)
    }

    return resultJson.result
  } catch (error) {
    return Promise.reject(error)
  }
}